import "./logo.css";
import { Link } from "react-router-dom";

export default function Logo() {
  return (
    <div className="logo">
      <Link to={'/'} className="logo--title">
      Leandro<strong>Salles</strong>
      </Link>
    </div>
  )
}
